import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div<{width?: string, height?: string, backgroundColor?: string}>`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : theme.colors.lightBlue4)};
    border: 1px solid ${theme.colors.darkGray};
    border-radius: 0.3rem;
    flex-grow: 1;
    width: ${(props) => (props.width ? props.width : null)};
    height: ${(props) => (props.height ? props.height : '2.5rem')};
`
